/* NexaNovo Carbon Gallery — 展厅顶栏的即时搜索
   走 Shopify 原生 predictive search（/search/suggest.json），不依赖主题里的搜索组件，
   所以换主题也不会坏。展开时把页面滚动整个锁掉 —— 不然一边打字一边镜头在飞。 */
(function () {
  const root = document.getElementById("nx-search");
  if (!root) return;

  const btn   = document.getElementById("nx-search-btn");
  const form  = document.getElementById("nx-search-form");
  const input = document.getElementById("nx-search-input");
  const panel = document.getElementById("nx-search-panel");
  const SEARCH_URL = root.dataset.searchUrl || "/search";
  const LIMIT      = 6;
  // 用店铺自己的 money_format 排版。别用 Intl：它跟着访客浏览器的语言走，
  // 同一个价格在中文浏览器上是 "US$174.89"、站内其它地方是 "$174.89"，两套写法。
  // money_format 里常有 &euro; &pound; 这类实体，也有店把 <span class=money> 塞在里面；
  // 这边是按纯文本插的，所以先解实体再去标签。用 textarea 解 —— 它的内容是 RCDATA，
  // 只认字符实体、不会真的建出元素来，比 innerHTML 到 div 上安全。
  const FMT = (function (raw) {
    const ta = document.createElement("textarea");
    ta.innerHTML = raw || "${{amount}}";
    return (ta.value || "${{amount}}").replace(/<[^>]*>/g, "").trim();
  })(root.dataset.moneyFormat);

  const money = v => {
    const n = parseFloat(v);
    if (!isFinite(n)) return "";
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
      const dec   = key.indexOf("no_decimals") >= 0 ? 0 : 2;
      const thou  = key.indexOf("apostrophe_separator") >= 0 ? "'"
                  : key.indexOf("comma_separator") >= 0 ? "." : ",";
      const point = key.indexOf("comma_separator") >= 0 ? "," : ".";
      const parts = n.toFixed(dec).split(".");
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? int + point + parts[1] : int;
    });
  };
  // Shopify CDN 认 width 参数，缩略图别去拉 2160px 的原图
  const thumb = u => u ? u + (u.indexOf("?") < 0 ? "?" : "&") + "width=120" : "";

  // ---- 开关 -----------------------------------------------------------------
  let open = false, scrollY0 = 0;

  // 滚动锁：展厅的镜头是跟着 scrollY 走的，光靠"忽略 scroll 事件"不行 ——
  // 事件忽略了页面照样滚，关掉搜索的瞬间镜头会啪地跳过去。这里直接不让它滚。
  const eatWheel = e => { if (!panel.contains(e.target)) e.preventDefault(); };
  const eatKeys = e => {
    if (e.target === input) return;
    if (/^(PageUp|PageDown|Home|End|ArrowUp|ArrowDown)$/.test(e.key) || e.key === " ") e.preventDefault();
  };
  function lock(on) {
    if (on) {
      scrollY0 = window.scrollY;
      addEventListener("wheel", eatWheel, { passive: false });
      addEventListener("touchmove", eatWheel, { passive: false });
      addEventListener("keydown", eatKeys, { passive: false });
    } else {
      removeEventListener("wheel", eatWheel, { passive: false });
      removeEventListener("touchmove", eatWheel, { passive: false });
      removeEventListener("keydown", eatKeys, { passive: false });
      if (window.scrollY !== scrollY0) window.scrollTo(0, scrollY0);
    }
  }

  function setOpen(v) {
    if (v === open) return;
    open = v;
    root.classList.toggle("on", v);
    btn.setAttribute("aria-expanded", String(v));
    lock(v);
    if (v) {
      input.focus(); input.select();
      const q = input.value.trim();
      if (q.length >= 2) run(q);              // 关掉再打开，原来的结果直接回来
    } else {
      hidePanel();
      lastQ = "";                             // 面板已经清空，同一个词要能重查
      input.blur();
    }
  }

  btn.addEventListener("click", () => setOpen(true));

  addEventListener("keydown", e => {
    if (e.key === "Escape" && open) { e.preventDefault(); setOpen(false); return; }
    if (open) return;
    // "/" 开搜索是这类站点的通用手势；Cmd/Ctrl+K 给键盘党
    const typing = /^(INPUT|TEXTAREA|SELECT)$/.test((e.target.tagName || "")) || e.target.isContentEditable;
    if ((e.key === "/" && !typing && !e.metaKey && !e.ctrlKey) ||
        (e.key.toLowerCase() === "k" && (e.metaKey || e.ctrlKey))) {
      e.preventDefault();
      setOpen(true);
    }
  });

  addEventListener("pointerdown", e => {
    if (!open || root.contains(e.target)) return;
    const onCanvas = e.target.tagName === "CANVAS";
    setOpen(false);
    // 点在展厅画布上只是"关掉搜索"，不该顺手把那一下也算成"点展品进详情"
    if (onCanvas) addEventListener("click", ev => {
      ev.stopPropagation(); ev.preventDefault();
    }, { capture: true, once: true });
  });

  form.addEventListener("submit", e => {
    // 有高亮项就走高亮项，否则交给 Shopify 的搜索结果页
    if (sel >= 0 && rows[sel]) { e.preventDefault(); rows[sel].click(); }
  });

  // ---- 取数 -----------------------------------------------------------------
  let timer = null, ctrl = null, lastQ = "";
  const cache = new Map();

  input.addEventListener("input", () => {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { lastQ = ""; hidePanel(); return; }
    if (q === lastQ) return;
    timer = setTimeout(() => run(q), 160);        // 打字停下来再发，别一个字母一个请求
  });

  async function run(q) {
    lastQ = q;
    if (cache.has(q)) { render(q, cache.get(q)); return; }
    panel.classList.add("busy");
    showPanel();
    if (ctrl) ctrl.abort();                        // 上一个请求的结果已经没意义了
    ctrl = new AbortController();
    const url = SEARCH_URL + "/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product,collection,query&resources[limit]=" + LIMIT +
      "&resources[options][unavailable_products]=last";
    try {
      const r = await fetch(url, { signal: ctrl.signal });
      if (!r.ok) throw new Error(r.status);
      const j = await r.json();
      const res = (j.resources && j.resources.results) || {};
      cache.set(q, res);
      if (lastQ === q) render(q, res);
    } catch (err) {
      if (err.name === "AbortError") return;
      panel.classList.remove("busy");
      panel.textContent = "";
      panel.appendChild(el("div", "nxs-empty", "Search is unavailable right now."));
    }
  }

  // ---- 渲染 -----------------------------------------------------------------
  // 全部用 textContent 建节点：商品标题是店里录的自由文本，不往 innerHTML 里塞。
  let rows = [], sel = -1;

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  function render(q, res) {
    panel.classList.remove("busy");
    panel.textContent = "";
    rows = []; sel = -1;

    const products    = res.products || [];
    const collections = res.collections || [];
    const queries     = res.queries || [];

    if (!products.length && !collections.length && !queries.length) {
      panel.appendChild(el("div", "nxs-empty", "No match for “" + q + "”"));
      showPanel();
      return;
    }

    if (products.length) {
      panel.appendChild(el("div", "nxs-head", "Parts"));
      products.forEach(p => {
        const a = el("a", "nxs-row");
        a.href = p.url;
        a.setAttribute("role", "option");

        const img = el("img", "nxs-thumb");
        img.src = thumb((p.featured_image && p.featured_image.url) || p.image);
        img.alt = ""; img.loading = "lazy"; img.width = 46; img.height = 46;
        a.appendChild(img);

        const box = el("div", "nxs-txt");
        box.appendChild(el("div", "nxs-t", p.title));
        const meta = el("div", "nxs-m");
        const price = money(p.price != null ? p.price : p.price_min);
        if (price) meta.appendChild(el("span", "p", price));
        if (p.available === false) meta.appendChild(el("span", "so", "Sold out"));
        else if (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price))
          meta.appendChild(el("span", "was", money(p.compare_at_price_max)));
        box.appendChild(meta);
        a.appendChild(box);

        panel.appendChild(a);
        rows.push(a);
      });
    }

    if (collections.length) {
      panel.appendChild(el("div", "nxs-head", "Collections"));
      collections.forEach(c => {
        const a = el("a", "nxs-row lite");
        a.href = c.url;
        a.setAttribute("role", "option");
        a.appendChild(el("span", "nxs-ic", "◇"));
        a.appendChild(el("div", "nxs-t", c.title));
        panel.appendChild(a);
        rows.push(a);
      });
    }

    if (queries.length) {
      panel.appendChild(el("div", "nxs-head", "Suggestions"));
      queries.slice(0, 3).forEach(s => {
        const a = el("a", "nxs-row lite");
        a.href = s.url;
        a.setAttribute("role", "option");
        a.appendChild(el("span", "nxs-ic", "↗"));
        a.appendChild(el("div", "nxs-t", s.text));
        panel.appendChild(a);
        rows.push(a);
      });
    }

    const all = el("a", "nxs-all", "See all results for “" + q + "”");
    all.href = SEARCH_URL + "?q=" + encodeURIComponent(q);
    panel.appendChild(all);
    rows.push(all);

    rows.forEach((r, i) => r.addEventListener("pointerenter", () => mark(i)));
    showPanel();
  }

  function mark(i) {
    if (rows[sel]) rows[sel].classList.remove("sel");
    sel = i;
    const r = rows[sel];
    if (!r) return;
    r.classList.add("sel");
    // 手动滚面板，不用 scrollIntoView —— 那个有可能连带把整页也滚了，
    // 而页面一滚展厅的镜头就跟着飞。
    const top = panel.scrollTop, h = panel.clientHeight;
    if (r.offsetTop < top) panel.scrollTop = r.offsetTop - 8;
    else if (r.offsetTop + r.offsetHeight > top + h)
      panel.scrollTop = r.offsetTop + r.offsetHeight - h + 8;
  }

  input.addEventListener("keydown", e => {
    if (!rows.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); mark(sel + 1 >= rows.length ? 0 : sel + 1); }
    else if (e.key === "ArrowUp") { e.preventDefault(); mark(sel - 1 < 0 ? rows.length - 1 : sel - 1); }
  });

  function showPanel() { panel.classList.add("on"); }
  function hidePanel() {
    panel.classList.remove("on", "busy");
    panel.textContent = "";
    rows = []; sel = -1;
  }
})();
